var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.866 38.8a15.897 15.897 0 0 1-3.441-5.13 15.748 15.748 0 0 1-1.203-6.058c0-4.38-1.774-8.329-4.634-11.2a15.805 15.805 0 0 0-11.2-4.634A15.785 15.785 0 0 1 61.2 7.134 15.783 15.783 0 0 0 50 2.5a15.783 15.783 0 0 0-11.2 4.634c-1.488 1.488-3.23 2.65-5.13 3.44s-3.958 1.204-6.058 1.204c-4.38 0-8.329 1.774-11.2 4.634a15.805 15.805 0 0 0-4.634 11.2c0 2.1-.411 4.159-1.203 6.059a15.897 15.897 0 0 1-3.441 5.13A15.783 15.783 0 0 0 2.5 50c0 4.053 1.541 8.107 4.634 11.2a15.897 15.897 0 0 1 3.441 5.13 15.748 15.748 0 0 1 1.203 6.058c0 4.38 1.774 8.329 4.634 11.2a15.805 15.805 0 0 0 11.2 4.634c2.1 0 4.159.411 6.059 1.203s3.641 1.953 5.13 3.441A15.783 15.783 0 0 0 50 97.5c4.053 0 8.107-1.541 11.2-4.634 1.488-1.488 3.23-2.65 5.13-3.44s3.958-1.204 6.058-1.204c4.38 0 8.329-1.774 11.2-4.634a15.805 15.805 0 0 0 4.634-11.2c0-2.1.411-4.159 1.203-6.059a15.897 15.897 0 0 1 3.441-5.13A15.783 15.783 0 0 0 97.5 50c0-4.053-1.541-8.107-4.634-11.2zm-19.865.148L44.933 67.016a4.226 4.226 0 0 1-5.974 0l-11.96-11.96a4.23 4.23 0 0 1 0-5.974 4.23 4.23 0 0 1 5.975 0l8.972 8.983 25.08-25.08a4.23 4.23 0 0 1 5.975 0 4.218 4.218 0 0 1 0 5.963z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.247947568a3d03824df5d414663a081f.svg";
export { ForwardRef as ReactComponent };